import { GetOutGoingCallOnSecretaryErrorPayLoad, GetOutGoingCallOnSecretaryRequestPayload, GetOutGoingCallOnSecretarySuccessPayload, SetOutGoingCallOnSecretaryErrorPayLoad, SetOutGoingCallOnSecretaryRequestPayload, SetOutGoingCallOnSecretarySuccessPayload } from "../interfaces/callDirectOnSeretary"
import { Types } from "../types"
import { GetOutGoingCallOnSecretaryError, GetOutGoingCallOnSecretaryRequest, GetOutGoingCallOnSecretarySuccess, SetOutGoingCallOnSecretaryError, SetOutGoingCallOnSecretaryRequest, SetOutGoingCallOnSecretarySuccess, resetSetOutGoingCallOnSecretary } from "../types/outGoingCallOnSecretary/actionType"


export const getOutGoingCallOnSecretaryRequestAction = (payload: GetOutGoingCallOnSecretaryRequestPayload): GetOutGoingCallOnSecretaryRequest => ({
    type: Types.GET_OUT_GOING_ON_SECRETARY_SETTINGS_REQUEST,
    payload
})

export const getOutGoingCallOnSecretarySuccessAction = (payload: GetOutGoingCallOnSecretarySuccessPayload): GetOutGoingCallOnSecretarySuccess => ({
    type: Types.GET_OUT_GOING_ON_SECRETARY_SETTINGS_SUCCESS,
    payload
})

export const getOutGoingCallOnSecretaryErrorAction = (payload: GetOutGoingCallOnSecretaryErrorPayLoad): GetOutGoingCallOnSecretaryError => ({
    type: Types.GET_OUT_GOING_ON_SECRETARY_SETTINGS_ERROR,
    payload
})

//set

export const setOutGoingCallOnSecretaryRequestAction = (payload: SetOutGoingCallOnSecretaryRequestPayload): SetOutGoingCallOnSecretaryRequest => ({
    type: Types.SET_OUT_GOING_ON_SECRETARY_SETTINGS_REQUEST,
    payload
})

export const setOutGoingCallOnSecretarySuccessAction = (payload: SetOutGoingCallOnSecretarySuccessPayload): SetOutGoingCallOnSecretarySuccess => ({
    type: Types.SET_OUT_GOING_ON_SECRETARY_SETTINGS_SUCCESS,
    payload
})

export const setOutGoingCallOnSecretaryErrorAction = (payload: SetOutGoingCallOnSecretaryErrorPayLoad): SetOutGoingCallOnSecretaryError => ({
    type: Types.SET_OUT_GOING_ON_SECRETARY_SETTINGS_ERROR,
    payload
})
//reset
export const resetOutGoingCallOnSecretaryAction = ():resetSetOutGoingCallOnSecretary  => ({
    type: Types.RESET_OUT_GOING_ON_SECRETARY_SETTINGS,    
})
